<template>
  <div>
    <BreadCrumb
      :path="[
        {
          title: `${userData.display_name}`,
        },
        {
          title: 'Contacts',
          route: '/contacts',
        },
        {
          title: 'Manage Roster',
          route: '/contacts/manageteam',
        },
      ]"
    />
    <MainContentPanel title="Manage Roster">
      <div class="uk-flex">
        <MainContentPanel title="MyPeople" :medium="true" padding="small" class="container-width">
          <div
            class="save-team-table"
            id="contact-table"
            @dragover.prevent
            @dragenter.prevent
            @drop="drop"
          >
            <PrimeDataTable
              ref="peopleDataTable"
              :pagination="false"
              :tableConfig="tablePeopleConfig"
              :tableOptions="tablePeopleOptions"
              :loadDataFunction="loadContacts"
              @selectedRows="data => (selectedPeople = data)"
              :updatedTableData="contacts"
              @startDrag="startDrag"
              @selectedColumns="tableToggleData"
            />
          </div>
        </MainContentPanel>
        <div class="uk-flex uk-flex-column uk-margin-small-left uk-margin-small-right">
          <div style="flex-grow: 1"></div>
          <div>
            <div
              @click="moveContacts('to')"
              class="uk-button uk-button-secondary uk-border-rounded-top"
            >
              <span uk-icon="icon: arrow-right" class="arrow-btn"></span>
            </div>
          </div>
          <div>
            <div
              @click="moveContacts('from')"
              class="uk-button uk-button-secondary uk-border-rounded-bottom"
            >
              <span uk-icon="icon: arrow-left" class="arrow-btn"></span>
            </div>
          </div>
          <div style="flex-grow: 1"></div>
        </div>
        <MainContentPanel
          headerInput="Name your Roster"
          :input="title"
          @inputChange="title = $event"
          UkButtonIcon="users"
          buttonText="Save Roster"
          :tooltip="
            !title
              ? 'You must give your team a name'
              : !teamContacts.length
                ? 'You must have at least one member on your team'
                : ''
          "
          padding="small"
          :medium="true"
          :buttonAction="saveTeam"
          :closeButton="true"
          :btnDisable="saveTeamDisable"
          @closeImportModal="backToContact"
          class="uk-width-1-2 uk-margin-remove-top"
        >
          <div
            class="save-team-table"
            id="team-contact-table"
            @dragover.prevent
            @dragenter.prevent
            @drop="drop"
          >
            <PrimeDataTable
              ref="teamDataTable"
              :pagination="false"
              :tableConfig="tableTeamConfig"
              :tableOptions="tableTeamOptions"
              :loadDataFunction="loadTeams"
              @selectedRows="data => (selectedTeamPeople = data)"
              :updatedTableData="teamContacts"
              @startDrag="startDrag"
            />
            <!-- // Team tags: Deprecated  -->
            <!-- @startDrag="startDrag" :addTag="true" @addTags="addTags" @removeTag="removeTag" :tagsData="tags" -->
          </div>
        </MainContentPanel>
      </div>
    </MainContentPanel>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import BreadCrumb from '@/components/general/BreadCrumb';
import MainContentPanel from '@/components/display/general/MainContentPanel';
import { mapActions, mapGetters, mapState } from 'vuex';
import { xhr } from '../../xhr/endpoints';
import { EventBus } from '@/assets/js/event-bus';

export default {
  name: 'ContactsTeamManage',

  components: {
    BreadCrumb,
    MainContentPanel,
    PrimeDataTable: defineAsyncComponent(() => import('@/components/table/PrimeDataTable.vue')),
  },
  data() {
    return {
      // Team tags: Deprecated
      // tags: [],
      title: '',
      // tagInput: "",
      dragData: {},
      contacts: [],
      teamContacts: [],
      selectedPeople: [],
      selectedTeamPeople: [],
      saveTeamDisable: true,
    };
  },
  watch: {
    title(value) {
      if (value && this.teamContacts.length) this.saveTeamDisable = false;
      else this.saveTeamDisable = true;
    },
    teamContacts(value) {
      if (value.length && this.title) this.saveTeamDisable = false;
      else this.saveTeamDisable = true;
    },
  },
  mounted() {
    EventBus.on('dblClick.add.data', this.dblClickRosterDataTransfer);
  },
  beforeUnmount() {
    EventBus.off('dblClick.add.data', this.dblClickRosterDataTransfer);
  },
  computed: {
    ...mapState(['idToken', 'userData']),

    ...mapGetters(['tableToggleData']),

    tablePeopleOptions() {
      return {
        // globalFilterFields: ["firstname"],
        tableName: 'tableContactsPeople',
        placeHolderData: true,
        rowSelectable: true,
        archiveSelected: {
          action: async ({ items, success, failed }) => {
            await this.archiveMultipleContacts(items, success, failed, true);
          },
          title: 'Archive Contacts',
          tooltip: 'Archive the checked contacts',
        },
        restoreSelected: {
          action: async ({ items, success, failed }) => {
            await this.archiveMultipleContacts(items, success, failed, false);
          },
          title: 'Restore Documents',
          tooltip: 'Restore archived items',
        },
      };
    },
    tablePeopleConfig() {
      const tableConfig = [
        {
          column: 'First Name',
          field: 'firstname',
          sortable: true,
          model: row => {
            return row.firstname;
          },
          draggable: true,
          from: 'contact',
          index: 1,
        },
        {
          column: 'Last Name',
          field: 'lastname',
          sortable: true,
          model: row => {
            return row.lastname;
          },
          draggable: true,
          from: 'contact',
          index: 2,
        },
        {
          column: 'Email',
          field: 'email',
          sortable: true,
          index: 3,
        },

        {
          column: 'Phone',
          field: 'phone',
          sortable: true,
          index: 4,
        },
        {
          column: '',
          field: 'archived',
          filter: {
            type: 'checkbox',
            text: 'Show Archived Contacts',
          },
        },
      ];
      return tableConfig;
    },
    tableTeamOptions() {
      return {
        selectable: true,
        rowSelectable: true,
        tableName: 'tableContactsTeam',
      };
    },
    tableTeamConfig() {
      const tableConfig = [
        {
          column: 'First Name',
          field: 'firstname',
          sortable: true,
          model: row => {
            return row.firstname;
          },
          draggable: true,
          from: 'teamcontact',
          index: 1,
        },
        {
          column: 'Last Name',
          field: 'lastname',
          sortable: true,
          model: row => {
            return row.lastname;
          },
          draggable: true,
          from: 'teamcontact',
          index: 2,
        },

        {
          column: 'Email',
          field: 'email',
          sortable: true,
          index: 3,
        },

        {
          column: 'Phone',
          field: 'phone',
          sortable: true,
          index: 4,
        },
      ];
      return tableConfig;
    },
  },
  methods: {
    ...mapActions(['loadMyContacts', 'addMyTeam', 'updateContact']),

    async saveTeam() {
      if (this.$route.query.teamId) {
        await xhr.updateTeam(
          this.$route.query.teamId,
          {
            team: {
              name: this.title,
              // Team tags: Deprecated
              // tags: this.tags,
              contacts: this.teamContacts.map(contact => contact._id),
              archived: false,
            },
          },
          this.idToken
        );
      } else {
        await this.addMyTeam({
          name: this.title,
          // Team tags: Deprecated
          // tags: this.tags,
          contacts: this.teamContacts.map(contact => contact._id),
          archived: false,
        });
      }
      this.$router.push('/contacts');
    },

    async loadTeams() {
      return {
        results: [...this.teamContacts],
        totalCount: this.teamContacts.length,
      };
    },
    backToContact() {
      this.$router.push('/contacts');
    },
    async loadContacts({ sortColumn, sortDirection, filters }) {
      if (window.location.href.match(/teamId=([^&]*)/)?.[1]) {
        const teamData = await xhr.getTeamDetails(this.$route.query.teamId, this.idToken);
        this.title = teamData.name;
        // Team tags: Deprecated
        // this.tags = team.tags
        this.selectedPeople = teamData.contacts;
        this.moveContacts('to');
      }
      const res = await this.loadMyContacts({
        sortColumn,
        sortDirection,
        filters,
      });
      let team = this.teamContacts.map(row => row._id);
      res.results = res.results.filter(data => !team.includes(data._id));
      this.contacts = res.results;
      return res;
    },
    dblClickRosterDataTransfer(data, name) {
      if (data && name === 'tableContactsPeople') {
        setTimeout(() => {
          this.moveContacts('to');
        }, 250);
      } else if (name === 'tableContactsTeam') {
        setTimeout(() => {
          this.moveContacts('from');
        }, 250);
      }
    },
    moveContacts(move) {
      if (move === 'to') {
        let selected = this.selectedPeople.map(row => row._id);
        this.contacts = this.contacts.filter(contact => {
          return !selected.includes(contact._id);
        });
        this.teamContacts = [...this.teamContacts, ...this.selectedPeople];
      } else if (move === 'from') {
        let selected = this.selectedTeamPeople.map(row => row._id);
        this.teamContacts = this.teamContacts.filter(contact => {
          return !selected.includes(contact._id);
        });
        this.contacts = [...this.contacts, ...this.selectedTeamPeople];
      }
    },

    drop(event) {
      let contactElm = document.getElementById('contact-table');
      let teamContactElm = document.getElementById('team-contact-table');
      if (teamContactElm.contains(event.srcElement) && this.dragData.from === 'contact') {
        if (!this.selectedPeople.length) {
          this.selectedPeople = [this.dragData.data];
        }
        this.moveContacts('to');
      } else if (contactElm.contains(event.srcElement) && this.dragData.from === 'teamcontact') {
        if (!this.selectedTeamPeople.length) {
          this.selectedTeamPeople = [this.dragData.data];
        }
        this.moveContacts('from');
      }
      this.dragData = {};
    },

    async archiveMultipleContacts(items, success, failed, archive) {
      try {
        for (let i = 0; i < items.length; i++) {
          let contact = items[i];
          contact.archived = archive;
          await this.updateContact([contact]);
        }
        if (success) success();
        this.$refs.peopleDataTable.loadData();
      } catch (e) {
        console.log(e);
        if (failed) failed();
      }
    },

    startDrag(data, from) {
      this.dragData = {
        data,
        from,
      };
    },
    // Team tags: Deprecated
    // addTags(value) {
    //   if (!value) return;
    //   this.tags.push(value);
    //   this.tagInput = ""
    // },

    // removeTag(index) {
    //   this.tags.splice(index, 1);
    // },
  },
};
</script>
<style lang="sass">
.container-width
  width: 45%

.tags-input
  padding: 5px 3px
  border: 1px solid
  border-radius: 5px
  margin: 5px 2px
.arrow-btn
  width: 20px
  height: 20px
.save-team-table
  height: 400px
  overflow: scroll
</style>
